import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    id: "",
    name: "",
    reloadFilters: false,
};

export const selectedProjectSlice = createSlice({
    name: "selectedProject",
    initialState,
    reducers: {
        selectProject: (_, action) => action.payload,
        toggleReloadFilters: (state, { payload }) => { state.reloadFilters = payload }
    }
})

export const { selectProject, toggleReloadFilters } = selectedProjectSlice.actions

export default selectedProjectSlice.reducer